<template>
  <component
    :is="tagName"
    :to="to || undefined"
    :href="href || undefined"
    :type="!to && !href ? type : undefined"
    :class="classes"
    :disabled="!to && !href ? (disabled || loading) : undefined"
    :aria-disabled="disabled || loading ? 'true' : undefined"
    :aria-busy="loading"
    @click="handleClick"
  >
    <span v-if="loading" class="v2-btn__spinner" aria-hidden="true" />
    <span v-else-if="icon" class="v2-btn__icon" aria-hidden="true">
      <v-icon :size="iconSize">{{ icon }}</v-icon>
    </span>
    <slot v-else name="icon-left" />
    <span class="v2-btn__label"><slot /></span>
    <slot name="icon-right" />
  </component>
</template>

<script>
export default {
  name: "BaseButton",
  props: {
    variant: {
      type: String,
      default: "primary",
      validator: (v) =>
        ["primary", "secondary", "ghost", "danger", "amber", "amber-outline", "navy"].includes(v),
    },
    size: {
      type: String,
      default: "md",
      validator: (v) => ["sm", "md", "lg"].includes(v),
    },
    type: {
      type: String,
      default: "button",
    },
    block: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    icon: { type: String, default: "" },
    to: { type: [String, Object], default: "" },
    href: { type: String, default: "" },
  },
  computed: {
    tagName() {
      if (this.to) return "router-link";
      if (this.href) return "a";
      return "button";
    },
    classes() {
      return [
        "v2-btn",
        `v2-btn--${this.variant}`,
        `v2-btn--${this.size}`,
        { "v2-btn--block": this.block, "v2-btn--loading": this.loading },
      ];
    },
    iconSize() {
      if (this.size === "sm") return 16;
      if (this.size === "lg") return 22;
      return 18;
    },
  },
  methods: {
    handleClick(e) {
      if (this.disabled || this.loading) {
        e.preventDefault();
        if (e.stopPropagation) e.stopPropagation();
        return;
      }
      this.$emit("click", e);
    },
  },
};
</script>

<style scoped>
.v2-btn__label {
  display: inline-flex;
  align-items: center;
}

.v2-btn__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.v2-btn__spinner {
  width: 1em;
  height: 1em;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: v2-btn-spin 0.6s linear infinite;
}

@keyframes v2-btn-spin {
  to { transform: rotate(360deg); }
}
</style>
